import React from "react";
import { motion } from "framer-motion";

import { Box, Grid, Typography, Container } from "@mui/material";
import { BorderClear } from "@mui/icons-material";

import CYBERSECURITYGRAPHICS from "../../assets/Graphics/CyberInfoGraphic.png";


const CyberPlan = () => {

    const CYBER_PLAN_BENEFITS = [
        {
            id: 1,
            title: "24/7 cyber support",
            descp:
                "Real-time technical support for threats, fraud, or suspicious activity.",
        },
        {
            id: 2,
            title: "Complete device protection",
            descp:
                "Malware removal, ransomware prevention and latest Antivirus support",
        },
        {
            id: 3,
            title: "Secure password practices",
            descp: "Guided password security with breach alerts.",
        },
        {
            id: 4,
            title: "Cyber protection insurance",
            descp: "Optional cover for financial loss due to cybercrime.",
        },
        {
            id: 5,
            title: "Data & identity theft assistance",
            descp:
                "Resolving impersonation issues, data leaks and retrieval of personal accounts.",
        },
    ];
    return (
        <Box>
            <Box sx={{ backgroundColor: "#fff6f1" }}>
                <Container>
                    <Grid container spacing={5} py={2} alignItems="center">
                        <Grid item xs={12} md={6} sx={{ maxWidth: 500 }}>
                            <motion.div
                                initial={{ x: -100, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                transition={{ duration: 1 }}
                            >
                                <Grid item xs={12} md={6}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            md={6}
                                            display="flex"
                                            // justifyContent="flex-end"
                                            justifyContent="center"
                                        >
                                            <Box
                                                component="img"
                                                src={CYBERSECURITYGRAPHICS}
                                                alt="Career Puzzle"
                                                sx={{
                                                    width: { xs: "100%", sm: "80%", md: "75%" },
                                                    maxHeight: "400px",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </motion.div>
                        </Grid>

                        <Grid item xs={12} md={6} ml={{ xs: 2, md: 0 }}>
                            <motion.div
                                initial={{ x: 100, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                transition={{ duration: 1 }}
                            >
                                {CYBER_PLAN_BENEFITS.map((step) => (
                                    <Box key={step.number} sx={{ display: "flex", mb: 1 }}>
                                        <motion.div
                                            initial={{ x: 100, opacity: 0 }}
                                            whileInView={{ x: 0, opacity: 1 }}
                                            transition={{ duration: 1 }}
                                        >
                                            <Box
                                                display={"flex"}
                                            >

                                                <Box
                                                    sx={{
                                                        bgcolor: "green",
                                                        color: "white",
                                                        width: 22,
                                                        height: 22,
                                                        //   borderRadius: "100%",
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontFamily: '"Poppins", serif',
                                                        fontSize: "0.8rem",
                                                        mt: {
                                                            xs: "0.9rem",
                                                            sm: "0.9rem",
                                                            md: "0.9rem",
                                                            lg: "0.9rem",
                                                        },
                                                        mr: 2,
                                                    }}
                                                >
                                                    {step?.id}
                                                </Box>

                                                <Box>
                                                    <Typography
                                                        fontWeight="600"
                                                        sx={{
                                                            fontFamily: '"Poppins", serif',
                                                            fontSize: { xs: "0.9rem", md: "0.96rem" },
                                                            mt: {
                                                                xs: "0.96rem",
                                                                sm: "0.96rem",
                                                                md: "0.96rem",
                                                                lg: "0.96rem",
                                                            },
                                                        }}
                                                    >
                                                        {step?.title}
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            fontFamily: '"Poppins", serif',
                                                            fontSize: { xs: "0.85rem", md: "0.9rem" },
                                                            mt: {
                                                                xs: "0.5rem",
                                                                sm: "0.5rem",
                                                                md: "0.5rem",
                                                                lg: "0.5rem",
                                                            },
                                                        }}
                                                    >
                                                        {step?.descp}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </motion.div>
                                    </Box>
                                ))}
                            </motion.div>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
};

export default CyberPlan;
